import apiClient from '../lib/apiClient';
import { Client } from '../types/client'; // Import Client type

export const getClients = async (page: number, limit: number): Promise<{ clients: Client[], total: number }> => {
  try {
    // Assuming the API returns data in the shape { clients: Client[], total: number }
    // Adjust the URL and expected response structure as per your API
    const response = await apiClient.get<{ clients: Client[], total: number }>(`/whatsapp/clients?page=${page}&limit=${limit}`);
    console.log({response});
    
    return response; 
  } catch (error) {
    console.error('Error fetching clients:', error);
    throw error; // Or handle more gracefully, e.g., return { clients: [], total: 0 }
  }
};

// Tipos de respuesta posibles (ajústalos a tu shape real)
export type ApiMessage = {
  id: number | string;
  timestamp: string; // o Date/number según tu API
  // ...otros campos
};

export type OffsetResp = {
  messages: ApiMessage[];
  total: number;
  nextPage?: number;
};

export type Cursor = { beforeTimestamp: string; beforeId: number };
export type CursorResp = {
  messages: ApiMessage[];
  nextCursor?: Cursor;
};

export type GetMessagesResp = OffsetResp | CursorResp;

// Parámetros aceptados (offset o cursor)
export type GetMessagesQuery = {
  page?: number;
  limit?: number;           // alias de pageSize
  beforeId?: number;
};

export const getMessages = async (
  clientId: string | number,
  query: GetMessagesQuery
): Promise<GetMessagesResp> => {
  // construye params solo con lo presente
  const params: Record<string, any> = {};
  if (query.page != null) params.page = query.page;
  if (query.limit != null) params.limit = query.limit;
  if (query.beforeId != null) params.beforeId = query.beforeId;

  const response = await apiClient.get<GetMessagesResp>(
    `/whatsapp/messages/${clientId}`,
    { params }
  );
  return response;
};


// export const getMessages = async (clientId: string, page: number, limit: number): Promise<{ messages: Message[], total: number }> => {
//   try {
//     // Assuming the API returns data in the shape { messages: Message[], total: number }
//     // Adjust the URL and expected response structure as per your API
//     const response = await apiClient.get<{ messages: Message[], total: number }>(`/whatsapp/messages/${clientId}?page=${page}&limit=${limit}`);
//     console.log("getMessages",response)
//     return response;
//   } catch (error) {
//     console.error(`Error fetching messages for client ${clientId}:`, error);
//     throw error; // Or handle more gracefully, e.g., return { messages: [], total: 0 }
//   }
// };

export const sendMessage = async (
  channelId: string,
  clientId: string,
  message: string,
  mediaFile?: File,
  quotedMsgId?: string
): Promise<{ success: boolean; data?: any; error?: string }> => {
  try {
    const formData = new FormData();
    formData.append('channelId', channelId);
    formData.append('clientId', clientId);
    formData.append('message', message);

    if (mediaFile) {
      formData.append('mediaFiles', mediaFile, mediaFile.name);
    }

    if (quotedMsgId) {
      formData.append('quotedMsgId', quotedMsgId);
    }

    // Assuming apiClient.post returns the actual data payload directly.
    // If it returns the full Axios response, you might need to access response.data.
    // Adjust the type <{ success: boolean; data?: any }> if your API response structure is different.
    const response = await apiClient.post<{ success: boolean; messageId?: string; [key: string]: any }>('/whatsapp/send-message', formData);
    console.log("response",response)
    return { success: true, data: response };
  } catch (error: any) {
    console.error('Error sending message via API:', error);
    const errorMessage = error.response?.data?.message || error.message || 'Failed to send message due to an unexpected error';
    return { success: false, error: errorMessage };
  }
};

// New function to be added
export const getMessageMediaLink = async (messageId: string): Promise<{ url: string; fileName?: string; mimetype?: string }> => {
  try {
    // apiClient prepends /api, so this will become /api/whatsapp/message-media/${messageId}
    const response = await apiClient.get<{ url: string; fileName?: string; mimetype?: string }>(`/whatsapp/message-media/${messageId}`);
    return response;
  } catch (error) {
    console.error(`Error fetching media link for message ${messageId}:`, error);
    // Consider re-throwing or returning a specific error structure
    throw error;
  }
};

export const getMessageMediaView = async (messageId: string): Promise<{ url: string; fileName?: string; mimetype?: string }> => {
  try {
    // apiClient prepends /api, so this will become /api/whatsapp/message-media/${messageId}
    const response = await apiClient.get<{ url: string; fileName?: string; mimetype?: string }>(`/whatsapp/media/view/${messageId}`);
    return response;
  } catch (error) {
    console.error(`Error fetching media link for message ${messageId}:`, error);
    // Consider re-throwing or returning a specific error structure
    throw error;
  }
};
